<script lang="ts">
  import type { Snippet } from 'svelte';
  import type { HTMLButtonAttributes } from 'svelte/elements';

  interface Props extends Omit<HTMLButtonAttributes, 'class' | 'children'> {
    label: string;
    round?: boolean;
    class?: string;
    children: Snippet;
  }

  let { label, round = false, class: className = '', children, ...rest }: Props = $props();
</script>

<button
  {...rest}
  type="button"
  class={['stat-icon-button', round ? 'stat-icon-button--round' : '', className].filter(Boolean).join(' ')}
  aria-label={label}
  title={label}
>
  {@render children()}
</button>
